var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBug = function SvgIconBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.625 9.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 11H1.125a1 1 0 1 0 0 2H3.5v.5c0 .714.09 1.42.264 2.1l-2.005 1.16a1 1 0 1 0 1.001 1.73l1.734-1.002a8.499 8.499 0 0 0 15.012 0l1.734 1.003a1 1 0 0 0 1.001-1.732L20.236 15.6c.174-.68.264-1.386.264-2.1V13h2.375a1 1 0 1 0 0-2H20.5v-.5c0-.714-.09-1.42-.264-2.1l2.005-1.16a1 1 0 1 0-1.001-1.73l-1.734 1.002a8.5 8.5 0 0 0-15.012 0L2.76 5.509a1 1 0 1 0-1 1.732L3.762 8.4a8.5 8.5 0 0 0-.263 2.1zm3.904-5.096A6.5 6.5 0 0 1 18.5 10.5v.5h-13v-.5a6.5 6.5 0 0 1 1.904-4.596M18.5 13H13v6.923a6.5 6.5 0 0 0 5.5-6.423zM11 19.923V13H5.5v.5a6.5 6.5 0 0 0 5.5 6.423",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBug;